<template>
  <v-footer
      padless
      app
      inset
      absolute
      class="footer"
      :height="footerHeight"
      ref="footer"
  >
    <v-card
        flat
        tile
        width="100%"
    >
      <v-divider></v-divider>

      <v-container style="max-width: 1500px;">
        <v-layout row>
          <v-flex xs12 sm4 px-3 py-2>
            <div class="title mb-3">Contact</div>
            <div class="mb-3">
              <strong>Ulrich Elling - ViVerita Discovery</strong><br>
              Karl-Farkas-Gasse 22<br>
              1030 Vienna, Austria<br>
              <a href="mailto:uelling@viveritatx.com">
                <v-icon color="primary">mdi-email-outline</v-icon>&nbsp;uelling@viveritatx.com
              </a>
            </div>
            <div>
              <strong>Johannes Zuber - Research Institute of Molecular Pathology</strong><br>
              Campus-Vienna-Biocenter 1<br>
              1030 Vienna, Austria<br>
              <a href="mailto:johannes.zuber@imp.ac.at">
                <v-icon color="primary">mdi-email-outline</v-icon>&nbsp;johannes.zuber@imp.ac.at
              </a>
            </div>
          </v-flex>
          <v-flex xs12 sm8 px-3 py-2>
            <div class="title mb-3">Partners</div>
            <v-layout justify-space-between align-content-center wrap>
              <img src="../assets/img/imba.svg" alt="IMBA logo" class="mb-4 logo"/>
              <img src="../assets/img/oeaw.png" alt="ÖAW logo" class="mb-4 logo"/>
              <img src="../assets/img/imp.png" alt="IMP logo" class="mb-4 logo"/>
              <img src="../assets/img/vbc.svg" alt="VBC logo" class="mb-4 logo"/>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>

      <v-card-text class="text-center">
        {{ new Date().getFullYear() }} —
        <strong>
          <a href="https://www.vbcf.ac.at" target="_blank" class="light--text">VBCF</a>
        </strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    name: 'Footer',
    data() {
      return {
        footerHeight: null
      }
    },
    mounted() {
      this.setFooterHeight();
      window.addEventListener('resize', this.setFooterHeight);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.setFooterHeight);
    },
    methods: {
      setFooterHeight() {
        this.footerHeight = this.$refs.footer.$el.offsetHeight;
      }
    }
  }
</script>

<style scoped>
  .footer {
    width: auto;
  }

  .logo {
    height: 70px;
    margin-right: 2rem;
  }
</style>